<template>
  <div :class="prefixCls">
    <quill-editor
      v-model="content"
      ref="myQuillEditor"
      :options="editorOption"
      @blur="onEditorBlur($event)"
      @focus="onEditorFocus($event)"
      @ready="onEditorReady($event)"
      :disabled="disabled"

      @change="onEditorChange($event)">
    </quill-editor>
    <pt-oss-upload @onSuccess="uploadFileSuccess" class="hide">
      <a-button ref="button"></a-button>
    </pt-oss-upload>
  </div>
</template>

<script>
import 'quill/dist/quill.snow.css'
import { quillEditor } from 'vue-quill-editor'

export default {
  name: 'PtQuillEditor',
  components: {
    quillEditor
  },
  props: {
    prefixCls: {
      type: String,
      default: 'ant-editor-quill'
    },
    disabled:{
      type:Boolean,
      default:false,
    },
    // 表单校验用字段
    // eslint-disable-next-line
    value: {
      type: String
    },
    placeholder:{
      type:String,
      default:'请输入...'
    }
  },
  data () {
    let _this = this;
    return {
      content: null,
      editorOption: {
        placeholder: this.placeholder,
        modules:{
          toolbar: {
            container:[
              ['bold', 'italic', 'underline', 'strike'],
              [{ 'list': 'ordered'}, { 'list': 'bullet' }],
              [{ 'indent': '-1'}, { 'indent': '+1' }],
              [{ 'header': 1 }, { 'header': 2 }],
              [{ 'script': 'sub'}, { 'script': 'super' }],
              ['image'],
              ['blockquote', 'code-block', {'align':[]}],
            ],
            handlers:{
              image(){
                console.log("点击 image")
                _this.$refs.button.$el.click()
              }
            }
          },
          // some quill options
          // imageResize: {
          //   displayStyles: {
          //     backgroundColor: 'black',
          //     border: 'none',
          //     color: 'white'
          //   },
          //   modules: ['Resize', 'DisplaySize']
          // }
        }
      }
    }
  },
  methods: {
    uploadFileSuccess(file,fileId){
      let url = this.$util.getPublicFileUrl(fileId);
      let quill = this.$refs.myQuillEditor.quill
      let length = quill.getSelection().index;
      quill.clipboard.dangerouslyPasteHTML(length, `<img src="${url}" width="100%" />`)
      quill.setSelection(length + 1)
    },
    onEditorBlur (quill) {

    },
    onEditorFocus (quill) {

    },
    onEditorReady (quill) {

    },
    onEditorChange ({ quill, html, text }) {
      console.log(html)
      this.$emit('change', html)
      this.$emit('input', html)
    }
  },
  watch: {
    value (val) {
      console.log(val)
      this.content = val
      this.$emit('input', val)
    }
  }
}
</script>
<style>

</style>
<style lang="less" scoped>
@import url('../index.less');

/* 覆盖 quill 默认边框圆角为 ant 默认圆角，用于统一 ant 组件风格 */
.ant-editor-quill {

  /deep/ .ql-toolbar{
    line-height: normal !important;
  }
  /deep/ .ql-toolbar.ql-snow {
    border-radius: @border-radius-base @border-radius-base 0 0;
  }
  /deep/ .ql-container.ql-snow {
    border-radius: 0 0 @border-radius-base @border-radius-base;
  }
  /deep/ .ql-editor{
    min-height:450px;
    line-height: normal;
  }
}
  .hide{
    display: none;
  }
</style>
